// import { NAME } from './constants'

export const getAll = () =>
  ({ data: { tags: ['Pozostałości', 'Rezygnacje', 'Wypisy'] } })
